import { render, staticRenderFns } from "./AddManage.vue?vue&type=template&id=ce3373ec&scoped=true";
import script from "./AddManage.vue?vue&type=script&lang=js";
export * from "./AddManage.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "ce3373ec", null);
export default component.exports;